import axios from 'axios';
import { IMPORT_API_URL } from 'src/shared/constants/api';
import { getAccessToken } from 'src/shared/utils/auth';
import { getLocale } from 'src/shared/utils/languages';
import { UserService } from 'src/store/auth/user-service';

const importAgent = axios.create({
  baseURL: IMPORT_API_URL,
  headers: {
    'content-type': 'application/json',
  },
});

importAgent.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === 401) {
      const accessToken = await UserService.updateToken();

      if (error?.config && accessToken) {
        return axios.request({
          ...error.config,
          headers: {
            ...error.config.headers,
            Authorization: `Bearer ${accessToken}`,
          },
        });
      }
    }

    return Promise.reject(error);
  },
);

importAgent.interceptors.request.use((config) => {
  const accessToken = getAccessToken();

  Object.entries(config.headers).forEach(([headerName, headerValue]) => {
    config.headers.set(headerName, headerValue);
  });
  config.headers['accept-language'] = getLocale();

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
});

export { importAgent };
